<template>
  <div class="saas-section">
    <div v-if="block.title" class="saas-section__title">
      <h2 class="saas-striped-title">{{ block.title }}</h2>
    </div>
    <PageTimeline :items="block.items"></PageTimeline>
  </div>
</template>

<script>
import PageTimeline from '@saas/components/page/PageTimeline'

export default {
  name: 'PageBlockTimeline',
  components: { PageTimeline },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
}
</script>
